var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"c-header"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',{staticClass:"u-visually-hidden"},[_vm._v("Bob Pendar-Hughes")]),_c('div',{staticClass:"c-header__logo"},[_c('Logo')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }